import { render, staticRenderFns } from "./CardSituacaoDaCota.vue?vue&type=template&id=db36eb98&scoped=true&"
import script from "./CardSituacaoDaCota.vue?vue&type=script&lang=js&"
export * from "./CardSituacaoDaCota.vue?vue&type=script&lang=js&"
import style0 from "./CardSituacaoDaCota.vue?vue&type=style&index=0&id=db36eb98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db36eb98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow,VSkeletonLoader})
